// ©2024 Austin App House. All rights reserved.
import Notification from '../../../components/notification';

const addFundingSourceToDwollaBySuperAdminOnSubmit = (values) => {
  const result = {};
console.log(values)
  if (!values.name) {
    result.name = 'Please enter Bank Name';
    Notification('warning', {
      message: 'Please enter correct Bank Name',
    });
  }
  
  if (!values.routing) {
    result.routing = 'Please enter Routing';
    Notification('warning', {
      message: 'Please enter Routing Number',
    });
  }
  if (values.routing && values.routing.length !== 9) { 
    result.routing = 'Routing number must be 9 digits';
    Notification('warning', {
      message: 'Routing number must be 9 digits',
    });
  }
  if (!values.account) {
    result.account = 'Please enter Account';
    Notification('warning', {
      message: 'Please enter Account Number',
    });
  }
  if (!values?.accountStatus?.value) {
    result.accountStatus = 'Please select Account Status';
    Notification('warning', {
      message: 'Please select Account Status',
    });
  }
  return result;
};

export default addFundingSourceToDwollaBySuperAdminOnSubmit;
